import { useDispatch, useSelector } from "react-redux";
import styled from "styled-components";
import Button from "../../shared/button/Btn";
import { useLocation } from "react-router-dom";
import { useEffect } from "react";
import { showModal, showNestedModal } from "../../../features/modal/modalSlice";
import { useScrollLock } from "../../../hooks/useScrollLock";
import PageTopTitle from "../../shared/PageTopTitle";
import {
  adminAracCezaSorgula,
  adminAracMuayeneSorgula,
  adminAracYetkiBelgesiSorgula,
  adminGetTrailerDoc,
  adminGetTruckDoc,
} from "../../../features/admin2/admin2Slice";

const Container = styled.div`
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.6);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 99;

  .modal {
    width: 550px;
    height: auto;
    color: ${({ theme }) => theme.mainTextColor};
    background-color: ${({ theme }) => theme.mainBgColor};
    border-radius: 10px;
    padding-block: 20px;
    overflow: auto;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    .content {
      padding: 20px;
      button {
        margin-block: 10px;
      }
    }
    .btn {
      padding-inline: 20px;
      display: flex;
      align-items: center;
      justify-content: center;
      button {
        margin-inline: 10px;
      }
    }
  }
`;

const KooperatifAraclarOptionsModal = () => {
  const { modalLocation } = useSelector((state) => state.modal);
  const { selectAdminArac } = useSelector((state) => state.admin2);
  const dispatch = useDispatch();
  const location = useLocation();
  const { lockScroll, unlockScroll } = useScrollLock();

  // //! bu modal açıldığnda ekran ı lock lamak için
  useEffect(() => {
    lockScroll();

    return () => {
      unlockScroll();
    };
  }, [lockScroll, unlockScroll]);

  // //! bu başka bir sayfaya geçildiğinde modal ı kapatmak için
  useEffect(() => {
    if (location.pathname !== modalLocation) {
      dispatch(showModal(null));
    }
  }, [dispatch, location.pathname, modalLocation]);


  return (
    <Container onClick={() => dispatch(showModal(null))}>
      <div className="modal" onClick={(e) => e.stopPropagation()}>
        <PageTopTitle title={"Araç Ekle"} />
        <div className="content">
          <Button
            handleClick={() => {
              dispatch(adminAracCezaSorgula(selectAdminArac?.truckPlateNumber));
            }}
            width="100%"
            padding="10px"
            bgColor="transparent"
            color={"#E85446"}
          >
            Ceza Sorgula
          </Button>
          <Button
            handleClick={() => {
              dispatch(
                adminAracYetkiBelgesiSorgula(selectAdminArac?.truckPlateNumber)
              );
            }}
            width="100%"
            padding="10px"
            bgColor="transparent"
            color={"#E85446"}
          >
            Yetki Belgesi Sorgula
          </Button>
          <Button
            handleClick={() => {
              dispatch(
                adminAracMuayeneSorgula(selectAdminArac?.truckPlateNumber)
              );
            }}
            width="100%"
            padding="10px"
            bgColor="transparent"
            color={"#E85446"}
          >
            Muayene Sorgula
          </Button>
          <Button
            handleClick={() => {
              dispatch( (selectAdminArac?.truckType === "Y.Römork" || selectAdminArac?.truckType === "Römork")
              ? adminGetTrailerDoc(selectAdminArac?.truckPlateNumber)
              : adminGetTruckDoc(selectAdminArac?.truckPlateNumber)
              );

              dispatch((selectAdminArac?.truckType === "Y.Römork" || selectAdminArac?.truckType === "Römork")
              ? showModal("adminDorseBelgeIslemler")
              : showModal("adminAraclarBelgeIslemler")
              )
            }}
            width="100%"
            padding="10px"
            bgColor="transparent"
            color={"#E85446"}
          >
            Araç Belgelerini Güncelle
          </Button>
          <Button
            handleClick={() => {
              dispatch(showModal("kooperatifAracGuncelle"));
            }}
            width="100%"
            padding="10px"
            bgColor="transparent"
            color={"#E85446"}
          >
            Aracı Güncelle
          </Button>
          <Button
            handleClick={() => {
              dispatch(showNestedModal("adminAracSil"));
            }}
            width="100%"
            padding="10px"
            bgColor="transparent"
            color={"#E85446"}
          >
            Aracı Sil
          </Button>
        </div>
        <div className="btn">
          <Button
            width="150px"
            handleClick={() => dispatch(showModal(null))}
            padding="10px"
            bgColor="#E85446"
            color={"#fff"}
          >
            Kapat
          </Button>
        </div>
      </div>
    </Container>
  );
};

export default KooperatifAraclarOptionsModal;
